import React, { useState, useEffect } from "react";
import { TranslationEditor } from "@cadenza/i18n-ui";
import { ColorPicker } from "@cadenza/theme";
import { EditorPreferencesPanel } from "@cadenza/preferences";
import { APP } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";
import { MenuRoot, MenuButton, MenuList, MenuItem } from "@cadenza/ui";
import { FaCog, FaEdit, FaPalette, FaWrench } from "react-icons/fa";

const Settings = ({ messages = {}, menuListClassName = "dropdown-left" }) => {
  const { title = "Settings" } = messages;

  const [showEditor, setShowEditor] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showEditorPreferences, setShowEditorPreferences] = useState(false);

  const openEditor = () => setShowEditor(true);
  const openColorPicker = () => setShowColorPicker(true);
  const openEditorPreferences = () => setShowEditorPreferences(true);

  const { STRINGS = {} } = useLanguageContext() || {};

  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === "Escape") {
        setShowEditor(false);
        setShowColorPicker(false);
        setShowEditorPreferences(false);
      }
    };
    window.addEventListener("keydown", escHandler);
    return () => window.removeEventListener("keydown", escHandler);
  }, []);

  return (
    <div>
      <MenuRoot>
        {(api) => (
          <div>
            <MenuButton
              api={api}
              aria-label={title}
              title={title}
              className="actionButton"
              showCaret={false}
            >
              <FaCog className="cs-big-icon" />
            </MenuButton>
            <MenuList api={api} className={menuListClassName}>
              <MenuItem onClick={openColorPicker}>
                <FaPalette className="cs-icon" style={{ marginRight: "8px" }} />
                {STRINGS[APP.CUSTOM_COLOR]}
              </MenuItem>
              {EditorPreferencesPanel && (
                <MenuItem onClick={openEditorPreferences}>
                  <FaWrench
                    className="cs-icon"
                    style={{ marginRight: "8px" }}
                  />
                  {STRINGS[APP.EDITORPREFS]}
                </MenuItem>
              )}
              <MenuItem onClick={openEditor}>
                <FaEdit className="cs-icon" style={{ marginRight: "8px" }} />
                {STRINGS[APP.TRANSLATION_EDITOR]}
              </MenuItem>
            </MenuList>
          </div>
        )}
      </MenuRoot>

      {showColorPicker && (
        <ColorPicker onClose={() => setShowColorPicker(false)} />
      )}

      {showEditorPreferences && EditorPreferencesPanel && (
        <EditorPreferencesPanel
          onClose={() => setShowEditorPreferences(false)}
        />
      )}

      {showEditor && (
        <div
          className="translation-editor-panel"
          role="dialog"
          aria-modal="true"
        >
          <button
            className="translation-editor-close"
            aria-label="Close translation editor"
            onClick={() => setShowEditor(false)}
          >
            &times;
          </button>
          <TranslationEditor />
        </div>
      )}
    </div>
  );
};

export default Settings;
